import { Navigate, RouteObject } from "react-router-dom";
import DefaultLayout from "./components/layouts/DefaultLayout";
import HomePage from "./components/pages/HomePage";
import ReportsPage from "./components/pages/ReportsPage";
import SettingsPage from "./components/pages/SettingsPage";
import SitesPage from "./components/pages/SitesPage";
import JobPage from "./components/pages/JobPage";
import AddEditSitePage from "./components/pages/AddEditSitePage";
import SiteViewPage from "./components/pages/SiteViewPage";
import HomeDashboard from "./components/pages/HomeDashboard";
import JobViewPage from "./components/pages/JobViewPage";
import EditJobTypePage from "./components/pages/EditJobTypePage";
import CalendarPage from "./components/pages/CalendarPage";
import User from "./types/user";

const routes = (
  hasAdminAccess?: boolean,
  loggedInUser?: User
): RouteObject[] => [
  {
    path: "/",
    element: <DefaultLayout />,
    children: [
      { path: "home", element: <HomeDashboard />, index: true },
      { path: "home/:id", element: <HomePage />, index: true },
      { path: "reports", element: <ReportsPage />, index: true },
      {
        path: "settings",
        element:
          hasAdminAccess && loggedInUser ? (
            <SettingsPage />
          ) : (
            <Navigate to={"/home"} />
          ),
        index: true,
      },
      { path: "sites", element: <SitesPage />, index: true },
      { path: "site/edit/:id", element: <AddEditSitePage />, index: true },
      { path: "site/view/:id", element: <SiteViewPage />, index: true },
      { path: "job/:id?", element: <JobPage />, index: true },
      { path: "job/view/:id?", element: <JobViewPage />, index: true },
      { path: "job-type/:id?", element: <EditJobTypePage />, index: true },
      { path: "calendar", element: <CalendarPage />, index: true },
      { path: "", element: <Navigate to="/home" />, index: true },
      { path: "*", element: <Navigate to="/home" />, index: true },
    ],
  },
];

export default routes;
